import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { getUrlOptionsDetails } from '@bingads-webui-campaign-react/url-options';

export const UrlOptions = ({ data }) => {
  const i18n = useContext(I18nContext);
  const urlOptionsDetails = getUrlOptionsDetails(i18n, data);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Campaign URL Options') }}>
      <Text>{urlOptionsDetails}</Text>
    </PropertyRow>
  );
};

UrlOptions.propTypes = {
  data: PropTypes.shape({
    TrackingUrlTemplate: PropTypes.string,
    FinalUrlSuffix: PropTypes.string,
    UrlCustomParameters: PropTypes.arrayOf(PropTypes.shape({
      Key: PropTypes.string,
      Value: PropTypes.string,
    })),
  }),
};

UrlOptions.defaultProps = {
  data: {
    TrackingUrlTemplate: '',
    FinalUrlSuffix: '',
    UrlCustomParameters: [],
  },
};
